import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './containers/App';

import * as serviceWorker from './serviceWorker';
import { interceptors, store } from './helpers';

import 'antd/dist/antd.css';
import 'react-quill/dist/quill.snow.css';

import 'dood-react-components/build/index.css';

import './styles/index.scss';

interceptors.setup();

render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
